/* eslint-disable ember/no-computed-properties-in-native-classes, ember/no-runloop */
import Controller from '@ember/controller';
import { service } from '@ember/service';
import { sort } from '@ember/object/computed';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { later } from '@ember/runloop';
import { getTablePrintCss } from 'linced-app/utils/table';
import {
  cleanExcelSheetName,
  cleanFileName,
  uniqueSheetName,
} from '@linc-technologies/linced-common/utils/file-names';
import moment from 'moment';
import { naturalSort } from '@linc-technologies/linced-common/utils/sorting';

export default class EmergencyController extends Controller {
  @service
  excel;

  title = 'Emergency Class Lists';

  @sort('model.homerooms', naturalSort('name'))
  sortedHomerooms;

  @action
  downloadFullXlsx() {
    let sheets = [];
    let sheetNames = [];

    this.sortedHomerooms.forEach((homeroom) => {
      let sheetName = uniqueSheetName(
        cleanExcelSheetName(homeroom.name),
        sheetNames,
      );
      sheetNames.push(sheetName);

      sheets.push({
        name: sheetName,
        data: this.getExportData(homeroom),
      });
    });

    let fileName = `${this.title} ${moment().format('YYYY-MM-DD')}.xlsx`;

    this.excel.export(sheets, {
      multiSheet: true,
      fileName: cleanFileName(fileName),
    });
  }

  @action
  print() {
    let printer = window.open(
      'about:blank',
      '_blank',
      'menubar=yes,location=no,resizable=yes,scrollbars=yes,status=no,height=700,width=1024',
    );
    let classLists = document.querySelectorAll('.class-list');
    let content = getTablePrintCss(false);

    content += `
      <style>
        .table-tools button { display: none; }
        table { table-layout: fixed; }
      </style>
    `;

    classLists.forEach((classList, index) => {
      if (index !== 0) {
        content += `<div style="page-break-before: always"></div>`;
      }

      content += classList.outerHTML;
    });

    printer.document.body.innerHTML = content;

    later(
      this,
      (printer) => {
        printer.print();
        printer.close();
      },
      printer,
      500,
    );
  }

  getExportData(homeroom) {
    if (isEmpty(homeroom) || isEmpty(homeroom.currentLearners)) {
      return;
    }
    let data = [];

    // Class info
    data.push(
      [`${homeroom.name}`],
      [`${homeroom.staffNames} - ${homeroom.currentLearners.length} children.`],
    );

    // Column headers
    data.push([
      'Name (home phone)',
      'Caregiver',
      'Caregiver',
      'Child taken by',
    ]);

    // Data
    homeroom.currentLearners.forEach((learner) => {
      let learnerNumber = learner.person.get('fields.nzMOE:homePhone.value');

      if (isEmpty(learnerNumber)) {
        learnerNumber = '';
      } else {
        learnerNumber = ` (${learnerNumber})`;
      }

      let contacts = learner.person.learner.contacts.filter((contact) => {
        return contact.type === 1;
      });

      let caregiverOne = '';
      let caregiverTwo = '';

      if (contacts.length) {
        let contactOne = contacts[0];

        if (!isEmpty(contactOne.fullName)) {
          caregiverOne += contactOne.fullName;
        }
        let contactOneCaregiver = contactOne.caregiver;
        if (!isEmpty(contactOneCaregiver)) {
          let contactOnePhoneMobile = contactOneCaregiver.get(
            'fields.core:phoneMobile.value',
          );
          if (!isEmpty(contactOnePhoneMobile)) {
            caregiverOne += ` M - ${contactOnePhoneMobile}`;
          }

          let contactOnePhoneHome = contactOneCaregiver.get(
            'fields.core:phoneHome.value',
          );
          if (!isEmpty(contactOnePhoneHome)) {
            caregiverOne += ` H - ${contactOnePhoneHome}`;
          }

          let contactOnePhoneWork = contactOneCaregiver.get(
            'fields.core:phoneWork.value',
          );
          if (!isEmpty(contactOnePhoneWork)) {
            caregiverOne += ` W - ${contactOnePhoneWork}`;
          }
        }

        if (contacts.length >= 2) {
          let contactTwo = contacts[1];

          if (!isEmpty(contactTwo.fullName)) {
            caregiverTwo += contactTwo.fullName;
          }
          let contactTwoCaregiver = contactTwo.caregiver;
          if (!isEmpty(contactTwoCaregiver)) {
            let contactTwoPhoneMobile = contactTwoCaregiver.get(
              'fields.core:phoneMobile.value',
            );
            if (!isEmpty(contactTwoPhoneMobile)) {
              caregiverTwo += ` M - ${contactTwoPhoneMobile}`;
            }

            let contactTwoPhoneHome = contactTwoCaregiver.get(
              'fields.core:phoneHome.value',
            );
            if (!isEmpty(contactTwoPhoneHome)) {
              caregiverTwo += ` H - ${contactTwoPhoneHome}`;
            }

            let contactTwoPhoneWork = contactTwoCaregiver.get(
              'fields.core:phoneWork.value',
            );
            if (!isEmpty(contactTwoPhoneWork)) {
              caregiverTwo += ` W - ${contactTwoPhoneWork}`;
            }
          }
        }
      }

      data.push([
        `${learner.person.lastName}, ${learner.person.firstName}` +
          learnerNumber,
        caregiverOne,
        caregiverTwo,
        '',
      ]);
    });

    return data;
  }
}
